import { Container, Stack } from "@mui/joy";
import OnBoardingForm from "app/components/OnBoardingForm/OnBoardingForm";
import SignInForm from "app/components/SignInForm/SignInForm";
import SignUpForm from "app/components/SignUpForm/SignUpForm";
import ForgotPasswordForm from "app/components/ForgotPasswordForm/ForgotPasswordForm";
import Illustration from "assets/illustration-trees.svg";

type TypeBoardingForms = {
  type: "sign-in" | "sign-up" | "onboarding" | "forgot-password";
};
const OnBoardingPage = ({ type }: TypeBoardingForms) => {

  return (
    <Stack
      sx={{
        height: "100vh",
        overflow: "hidden",
        justifyContent: "center",
        p: { xs: 1, sm: 2, md: 4 },
        boxSizing: "border-box",
      }}
    >
      <Container
        sx={{
          display: "grid",
          gridTemplateColumns: { lg: '1fr 1fr' },
          borderRadius: "12px",
          gap: 4,
          backgroundColor: "white",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          p: { xs: 2, sm: 4, md: 15 },
          py: { xs: 4, md: 15 },
          justifyItems: "center",
          alignItems: "center",
          boxSizing: "border-box",
          overflow: 'auto',
        }}
      >
        {type == "sign-in" && <SignInForm />}
        {type == "sign-up" && <SignUpForm />}
        {type == "onboarding" && <OnBoardingForm />}
        {type == "forgot-password" && <ForgotPasswordForm />}
        <img
          src={Illustration}
          alt={"Illustration trees"}
          style={{ maxWidth: "calc(100vw - 10rem)" }}
        />
      </Container>
    </Stack>
  );
};

export default OnBoardingPage;
